<template>
  <div id="cardItem">
    <el-row>
      <el-button id="addBtn" type="primary" @click="toAddCustomer">添加色号</el-button>
    </el-row>

    <el-form id="queryForm" :inline="true" :model="queryForm" class="demo-form-inline">
      <CardSelector ref="cardSelector" />
      <el-form-item label="色号">
        <el-input v-model="queryForm.colorNo" placeholder="色号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData.list" :default-sort="{prop: 'date', order: 'descending'}" border>
      <el-table-column prop="weight" label="序号"></el-table-column>
      <el-table-column prop="cardName" label="色卡名称"></el-table-column>
      <el-table-column prop="colorNo" label="色号"></el-table-column>
      <el-table-column prop="colorName" label="颜色名"></el-table-column>
      <el-table-column prop="colorCode" label="HTML编码"></el-table-column>
      <el-table-column label="HTML颜色">
        <template slot-scope="scope">
          <div style="width:70px;height:25px" :style="{background:scope.row.colorCode}"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="removeCustomer(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="query"
      @size-change="changeSize"
      :current-page.sync="queryForm.pageNum"
      :page-sizes="[10,20,30,40,50]"
      :total="tableData.total"
      layout="total,sizes, prev, pager, next"
    ></el-pagination>

    <el-dialog title="添加色号" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form :model="form">
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input v-model="form.weight" autocomplete="off"></el-input>
        </el-form-item>
        <CardSelector ref="cardSelector1" :labelWidth="formLabelWidth" />
        <el-form-item label="色号" :label-width="formLabelWidth">
          <el-input v-model="form.colorNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="颜色名" :label-width="formLabelWidth">
          <el-input v-model="form.colorName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="HTML编码" :label-width="formLabelWidth">
          <el-input v-model="form.colorCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="html颜色" :label-width="formLabelWidth">
          <div :style="colorStyle"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveColor">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新色卡" :visible.sync="updateFormVisible" :width="dialogWidth">
      <el-form :model="updateForm">
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input v-model="updateForm.weight" autocomplete="off"></el-input>
        </el-form-item>
        <CardSelector ref="cardSelector2" :labelWidth="formLabelWidth" :cardId="updateForm.cardId" />
        <el-form-item label="色号" :label-width="formLabelWidth">
          <el-input v-model="updateForm.colorNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="颜色名" :label-width="formLabelWidth">
          <el-input v-model="updateForm.colorName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="HTML编码" :label-width="formLabelWidth">
          <el-input v-model="updateForm.colorCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="html颜色" :label-width="formLabelWidth">
          <div :style="updateColorStyle"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateColor">更 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CardSelector from "@/components/CardSelector.vue";
export default {
  components: {
    CardSelector
  },
  data() {
    return {
      tableData: [],
      updateFormVisible: false,
      dialogFormVisible: false,
      form: {},
      updateForm: {},
      formLabelWidth: "120px",
      dialogWidth: "600px",
      queryForm: {}
    };
  },
  computed: {
    colorStyle: function() {
      return { background: this.form.colorCode, width: "40px", height: "40px" };
    },
    updateColorStyle: function() {
      return {
        background: this.updateForm.colorCode,
        width: "40px",
        height: "40px"
      };
    }
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.dialogFormVisible = true;
    },
    changeSize(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.query();
    },
    query() {
      this.queryForm.cardId = this.$refs.cardSelector.selectCardId;
      var self = this;
      this.$axios
        .get("public/colorCard/queryColor", { params: self.queryForm })
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    saveColor() {
      this.form.cardId = this.$refs.cardSelector1.selectCardId;
      var self = this;
      this.$axios
        .post("colorCard/saveColor", self.form)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.dialogFormVisible = false;
            //清空表单
            self.form = {};
            self.$message({
              message: "保存成功",
              type: "success"
            });
            self.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    removeCustomer(row) {
      var self = this;

      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .delete("colorCard/removeColor/" + row.id)
            .then(function(response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                self.query();
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.updateForm = JSON.parse(JSON.stringify(row));
      this.updateFormVisible = true;
    },
    cardItem(index, row) {
      this.$router.push("/mpindex/cardItem/" + row.id);
    },
    updateColor() {
      this.updateForm.cardId = this.$refs.cardSelector2.selectCardId;
      var self = this;
      this.$axios
        .post("colorCard/updateColor", self.updateForm)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.updateFormVisible = false;
            self.$message({
              message: "更新成功",
              type: "success"
            });
            self.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    }
  },
  created: function() {
    console.log("mobileApp created");
    this.query();
  }
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
.el-table {
  margin: auto;
  width: 90%;
}
</style>